<div class="upload-container">
  <!-- Drop Zone -->
  <div class="drop-zone"
       (dragover)="onDragOver($event)"
       (drop)="onFileDropped($event)">
    <p *ngIf="selectedFiles.length === 0">Drag & Drop files here or</p>
    <p *ngIf="selectedFiles.length > 0">Selected Files:</p>

    <ng-container *ngIf="selectedFiles.length > 0">
      <div class="file-wrap" *ngFor="let file of selectedFiles">
        <p>{{ file.name }}</p> 
        <button mat-icon-button color="warn" (click)="removeFile(file)"><mat-icon>close</mat-icon></button>
      </div>
    </ng-container>

    <input type="file" hidden [id]="uniqueId" 
       [accept]="acceptedTypes" 
       [multiple]="allowMultiple"
       (change)="onFileSelected($event)">
    <label [for]="uniqueId" class="upload-button">Browse Files</label>
  </div>

  <!-- Previews -->
  <div class="preview" *ngIf="previewUrls.length > 0">
    <div *ngFor="let preview of previewUrls">
      <img [src]="preview" alt="File Preview">
    </div>
  </div>

  <!-- Clear All Button -->
  <button mat-flat-button color="warn" *ngIf="selectedFiles.length > 1" (click)="clearFiles()" class="clear-btn">Clear All</button>
</div>
